import { routes as _routes } from "../routes";

export const showDefaultLocale: boolean = false;

export const trailingSlash: "always" | "never" | "ignore" = "never";

export type Locale = "default" | "fr" | "de" | "nl" | "es" | "uk" | "au" | "cn" | "hk" | "id" | "in" | "jp" | "kr" | "sg" | "tw";
export type Handle = "default" | "fr" | "de" | "nl" | "es" | "uk" | "au" | "cn" | "hk" | "avptId" | "in" | "jp" | "kr" | "sg" | "tw";

export const localesList:Array<string> = [
    // North & South America
    "default", // : 'United States',
    // es: 'LATAM',
    // Europe, Middle East & Africa
    "fr", // 'France',
    "de", // 'Germany',
    "nl", // 'Netherlands',
    "es", // 'Spain',
    "uk", // 'United Kingdom',
    // Asia & Australia
    "au", // 'Australia',
    "cn", // 'China',
    "hk", // 'Hong Kong',
    "id", // 'Indonesia',
    "in", // 'India',
    "jp", // 'Japan',
    "kr", // 'Korea',
    "sg", // 'Singapore',
    "tw", // 'Taiwan'
];

export const locales:Record<Locale, string> = {
    // North & South America
    default: 'United States',
    // es: 'LATAM',
    // Europe, Middle East & Africa
    fr: 'France',
    de: 'Germany',
    nl: 'Netherlands',
    es: 'Spain',
    uk: 'United Kingdom',
    // Asia & Australia
    au: 'Australia',
    cn: 'China',
    hk: 'Hong Kong',
    id: 'Indonesia',
    in: 'India',
    jp: 'Japan',
    kr: 'Korea',
    sg: 'Singapore',
    tw: 'Taiwan'
};

export const siteNames: Record<Locale, string> = {
    // North & South America
    default: 'United States',
    // latam: 'LATAM',
    // Europe, Middle East & Africa
    fr: 'France',
    de: 'Germany',
    nl: 'Netherlands',
    es: 'Spain',
    uk: 'United Kingdom',
    // Asia & Australia
    au: 'Australia',
    cn: 'China',
    hk: 'Hong Kong',
    id: 'Indonesia',
    in: 'India',
    jp: 'Japan',
    kr: 'Korea',
    sg: 'Singapore',
    tw: 'Taiwan'
};

export const siteNamesShort: Record<Locale, string> = {
    // North & South America
    default: 'US',
    // latam: 'LATAM',
    // Europe, Middle East & Africa
    fr: 'FR',
    de: 'DE',
    nl: 'NL',
    es: 'ES',
    uk: 'UK',
    // Asia & Australia
    au: 'AU',
    cn: 'CN',
    hk: 'HK',
    id: 'ID',
    in: 'IN',
    jp: 'JP',
    kr: 'KR',
    sg: 'SG',
    tw: 'TW'
};

export const siteHandles: Record<Locale, Handle> = {
    // North & South America
    default: 'default',
    // latam: 'latam',
    // Europe, Middle East & Africa
    fr: 'fr',
    de: 'de',
    nl: 'nl',
    es: 'es',
    uk: 'uk',
    // Asia & Australia
    au: 'au',
    cn: 'cn',
    hk: 'hk',
    id: 'avptId',
    in: 'in',
    jp: 'jp',
    kr: 'kr',
    sg: 'sg',
    tw: 'tw'
};

export const langs:Record<string, string> = {
    // North & South America
    default: 'en-US',
    // latam: 'en',
    // Europe, Middle East & Africa
    fr: 'fr-FR',
    de: 'de-DE',
    nl: 'nl-NL',
    es: 'es-ES',        // 西班牙语（西班牙）
    uk: 'en-GB',        // 英式英语
    // Asia & Australia
    au: 'en-AU',        // 澳大利亚英语
    cn: 'zh-hans-CN',      // 简体中文（中国大陆）
    hk: 'zh-hant-HK',      // 繁体中文（香港）
    id: 'id-ID',           // 印度尼西亚语（印度尼西亚）
    jp: 'ja-JP',        // 日语（日本）
    kr: 'ko-KR',        // 韩语（韩国）
    sg: 'en-SG',        // 新加坡英语
    tw: 'zh-hant-TW',       // 繁体中文（台湾）
    in: 'en-IN'
};

export const ogLocales:Record<string, string> = {
    default: 'en_US',
    fr: 'fr_FR',
    de: 'de_DE',
    nl: 'nl_NL',
    es: 'es_ES',           // 西班牙语（西班牙）
    uk: 'en_GB',        // 英式英语
    au: 'en_AU',        // 澳大利亚英语
    cn: 'zh_CN',        // 简体中文（中国大陆）
    hk: 'zh_HK',        // 繁体中文（香港）
    id: 'id_ID',        // 印度尼西亚语（印度尼西亚）
    jp: 'ja_JP',        // 日语（日本）
    kr: 'ko_KR',        // 韩语（韩国）
    sg: 'en_SG',        // 新加坡英语
    tw: 'zh_TW',        // 繁体中文（台湾）
    in: 'en_IN'
};
export type UI = Record<Locale, Record<string, string>>;
// export declare const ui: UI;

export interface RegionsType {
    [key: string]: Record<string, Locale>;
};

export const regions:Record<string, Record<string, Locale>> = {
    "North & South America": {
        'United States': 'default',
        'LATAM': 'es',
    },
    "Europe, Middle East & Africa": {
        'France': 'fr', // fr-FR
        'Germany': "de", // de-DE
        'Netherlands': "nl", // nl-NL
        'Spain': "es", // es-ES
        'United Kingdom': "uk",
    },
    "Asia & Australasia": {
        'Australia': "au",
        'China': "cn",
        'Hong Kong': "hk",
        'Indonesia': "id", // id-ID
        'India': "in",
        'Japan': "jp",
        'Korea': "kr",
        'Singapore': "sg",
        'Taiwan': "tw"
    }
};

// export const defaultSite:Site = 'default';
export const defaultLocale:Locale = 'default';

export const defaultHandle:Handle = siteHandles[defaultLocale];

export const fallback:Record<string, Array<Locale>> = { // Locale
    // North & South America
    // default: undefined,
    // Europe, Middle East & Africa
    "uk": ['default'],
    "fr": ['default'],
    "de": ['default'],
    "nl": ['default'],
    "es": ['default'],
    // Asia & Australia
    "sg": ['default'],
    "au": ['default'],
    "cn": ['default'],
    "hk": ['default'],
    "id": ['default'],
    "jp": ['default'],
    "kr": ['default'],
    "tw": ['default'],
    "in": ['default'],
};

export const routes:Record<string, Record<string, string>> = _routes;

export const langToOgLocale = (lang: string): string | undefined => {
    const [locale] = Object.entries(langs).find(([k, v]) => v === lang) || [];
    return !!locale ? ogLocales[locale] : lang?.replace('-', '_');
}

export const ogLocaleToLang = (ogLocale: string): string | undefined => {
    const [locale] = Object.entries(ogLocales).find(([k, v]) => v === ogLocale) ?? [];
    return !!locale ? langs[locale] : ogLocale?.replace('_', '-');
}

export const defaultNS:string = "common";

export const ns:Array<string> = [
    defaultNS
];